import React from 'react';
import { Globe } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Button } from '@/components/ui/button';
import { useLocale } from '@/contexts/LocaleContext';
import { LOCALE_CONFIG, LocaleKey } from '@/i18n';

const LanguageSwitcher: React.FC = () => {
  const { locale, setLocale } = useLocale();
  const currentConfig = LOCALE_CONFIG[locale];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="sm" className="gap-2">
          <Globe className="h-4 w-4" />
          <span className="hidden sm:inline">{currentConfig.flag} {currentConfig.currency}</span>
          <span className="sm:hidden">{currentConfig.flag}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-48">
        {(Object.keys(LOCALE_CONFIG) as LocaleKey[]).map((key) => {
          const config = LOCALE_CONFIG[key];
          const isActive = key === locale;
          
          return (
            <DropdownMenuItem
              key={key}
              onClick={() => setLocale(key)}
              className={`flex items-center justify-between cursor-pointer ${
                isActive ? 'bg-accent' : ''
              }`}
            >
              <span className="flex items-center gap-2">
                <span>{config.flag}</span>
                <span>{config.name}</span>
              </span>
              <span className="text-muted-foreground text-sm">
                {config.currency}
              </span>
            </DropdownMenuItem>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default LanguageSwitcher;
